import type { EventEvolutionConfig } from "@nexus/widgets";

export type DetectionRepresentation = "smooth-line" | "stepped-line" | "stepped-area";
export type AnalyticsChartHeight = "standard" | "tall";

export interface AnalyticsVisualPreferences {
  detectionRepresentation: DetectionRepresentation;
  analyticsChartHeight: AnalyticsChartHeight;
}

export const DEFAULT_ANALYTICS_VISUAL_PREFERENCES: AnalyticsVisualPreferences = {
  detectionRepresentation: "smooth-line",
  analyticsChartHeight: "standard",
};

export function normalizeDetectionRepresentation(value: unknown): DetectionRepresentation {
  return value === "smooth-line" || value === "stepped-line" || value === "stepped-area"
    ? value
    : DEFAULT_ANALYTICS_VISUAL_PREFERENCES.detectionRepresentation;
}

export function normalizeAnalyticsChartHeight(value: unknown): AnalyticsChartHeight {
  return value === "standard" || value === "tall"
    ? value
    : DEFAULT_ANALYTICS_VISUAL_PREFERENCES.analyticsChartHeight;
}

export function withAnalyticsVisualPreferences<Config extends EventEvolutionConfig>(
  preferences: AnalyticsVisualPreferences,
  config: Config,
): Config & EventEvolutionConfig {
  return {
    detectionRepresentation: preferences.detectionRepresentation,
    ...config,
  };
}

export function eventEvolutionHeightClass(height: AnalyticsChartHeight): string {
  return height === "tall"
    ? "min-h-[clamp(32rem,calc(23.625rem+8.65vw),42rem)]"
    : "min-h-[clamp(25rem,calc(17.92rem+7.57vw),34rem)]";
}
